import { Navigate, Outlet } from "react-router-dom";

import { isSuperAdmin } from "../utils/Roles";
import { ROUTES_PATHS } from "../utils/RoutesPaths";

const PrivateRoutes = () => {
  return isSuperAdmin() ? <Outlet /> : <Navigate to={ROUTES_PATHS.owners} />;
};

export default PrivateRoutes;
